import CheckoutOverlay from '../../CheckoutOverlay';
import TrustlyOverlayLazyLoader from './TrustlyOverlayLazyLoader';

function TrustlyOverlay() {
  return (
    <CheckoutOverlay
      popup
      autosize
      stickyHeader
      nopadding
    >
      <TrustlyOverlayLazyLoader />
    </CheckoutOverlay>
  );
}

export default TrustlyOverlay;
